import { render } from "./ApprovementModal.vue?vue&type=template&id=5d3b68c2&scoped=true&ts=true"
import script from "./ApprovementModal.ts?vue&type=script&lang=ts"
export * from "./ApprovementModal.ts?vue&type=script&lang=ts"

import "./ApprovementModal.scss?vue&type=style&index=0&id=5d3b68c2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3b68c2"]])

export default __exports__